export const MINIAPP_SHARE_URL =
  "https://farcaster.xyz/miniapps/q-36IAPYR2_2/kawaii";

export const OPENSEA_URL = "https://opensea.io/collection/boxes-733036822";

export const PROFILE_URL = "https://farcaster.xyz/kawaiinyan.eth";
